// a library to wrap and simplify api calls
import axios from 'axios'

import { LOCALE } from '../constants/locale.constants'
import { type CompanyEmployeeToken } from '../types/UserStateType'

import UserI = AppleSignInAPI.UserI
import AuthorizationI = AppleSignInAPI.AuthorizationI

export const createNextApi = () =>
  axios.create({
    baseURL: `/api/${process.env.NEXT_PUBLIC_API_VERSION}/`,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': LOCALE,
      Accept: '*/*',
    },
    timeout: 20000,
  })

export const nextApi = createNextApi()

const endpoints = (api) => {
  const setHeader = (name: string, value: string) => {
    if (value) {
      api.defaults.headers.common[name] = value
    } else {
      delete api.defaults.headers.common[name]
    }
  }
  return {
    // POST
    login: (email: string, password: string, companyEmployee?: CompanyEmployeeToken) =>
      api.post('login', { email, password, companyEmployee }),
    loginFacebook: (code: string, companyEmployee: CompanyEmployeeToken, doNotCreateNewUser?: boolean) =>
      api.post('facebook/oauth', { code, companyEmployee, doNotCreateNewUser }),
    loginGoogle: (idToken: string, companyEmployee: CompanyEmployeeToken, doNotCreateNewUser?: boolean) =>
      api.post('google/oauth', { idToken, companyEmployee, doNotCreateNewUser }),
    loginApple: ({
      authorization,
      user,
      companyEmployee,
      doNotCreateNewUser,
    }: {
      authorization: AuthorizationI
      user: UserI
      companyEmployee?: CompanyEmployeeToken
      doNotCreateNewUser?: boolean
    }) => api.post('apple/oauth', { authorization, user, companyEmployee, doNotCreateNewUser }),
    resetPassword: (data: Record<string, any>) => api.post('register/reset-password-request', data),
    refreshToken: (refreshToken: string) =>
      api.post('oauth/refresh-token', {}, { headers: { Authorization: `Bearer ${refreshToken}` } }),
    register: (data: object) => api.post('register', data),
    registerFromSocial: (data: object) => api.post('register/from-social', data),
    addAddress: (address: string) => api.post('sendpulse/add-address', { address }),

    // helpers
    setHeader,
    setAuthorization: (auth: string) => {
      setHeader('Authorization', auth)
    },
  }
}

export const rawNextEndpoints = endpoints
export type NextApiEndpoints = ReturnType<typeof endpoints>

export default endpoints(nextApi)
